// Generated by backend/scripts/generate_scopes_ts.py — do not edit.
// Source of truth: backend/app/core/scopes.py
// Regenerate with scripts/generate-client.sh

export const PANEL = "panel:"
export const MCP = "mcp:"
export const QA = "qa:"
export const PAYMENTS_READ = "panel:payments:read"
export const PAYMENTS_SUBSCRIPTIONS_READ = "panel:payments:subscriptions:read"
export const PAYMENTS_GRANT = "panel:payments:grant"
export const PAYMENTS_TRIAGE = "panel:payments:triage"
export const PRICING_READ = "panel:pricing:read"
export const PRICING_WRITE = "panel:pricing:write"
export const USERS_READ = "panel:users:read"
export const USERS_PII_READ = "panel:users:pii:read"
export const USERS_WRITE = "panel:users:write"
export const USERS_ROLES_WRITE = "panel:users:roles:write"
export const USERS_ACTIVITY_READ = "panel:users:activity:read"
export const USERS_RELEASE_READ = "panel:users:release:read"
export const USERS_STATIC_CODE_READ = "panel:users:static-code:read"
export const USERS_STATIC_CODE_WRITE = "panel:users:static-code:write"
export const FEEDBACK_READ = "panel:feedback:read"
export const FEEDBACK_WRITE = "panel:feedback:write"
export const NOTIFICATIONS_READ = "panel:notifications:read"
export const NOTIFICATIONS_SEND = "panel:notifications:send"
export const COMMUNITY_READ = "panel:community:read"
export const COMMUNITY_MODERATE = "panel:community:moderate"
export const INSIGHTS_READ = "panel:insights:read"
export const METRICS_READ = "panel:metrics:read"
export const METRICS_WRITE = "panel:metrics:write"
export const PORTAL_READ = "panel:portal:read"
export const PORTAL_DRAFT = "panel:portal:draft"
export const PORTAL_PUBLISH = "panel:portal:publish"
export const LESSONS_READ = "panel:lessons:read"
export const LESSONS_WRITE = "panel:lessons:write"
export const LESSONS_PUBLISH = "panel:lessons:publish"
export const EXERCISES_READ = "panel:exercises:read"
export const EXERCISES_WRITE = "panel:exercises:write"
export const EXERCISES_PUBLISH = "panel:exercises:publish"
export const MEDIA_READ = "panel:media:read"
export const MEDIA_WRITE = "panel:media:write"
export const EMAIL_READ = "panel:email:read"
export const EMAIL_WRITE = "panel:email:write"
export const EMAIL_SEND = "panel:email:send"
export const EMAIL_TEST_SELF = "panel:email:test:self"
export const EMAIL_ADMIN = "panel:email:admin"
export const MAIL_SYSTEM_WRITE = "panel:mail:system:write"
export const PUSH_TEST_SELF = "panel:push:test:self"
export const CAMPAIGN_READ = "panel:campaign:read"
export const CAMPAIGN_DRAFT = "panel:campaign:draft"
export const CAMPAIGN_PUBLISH = "panel:campaign:publish"
export const SEGMENTS_READ = "panel:segments:read"
export const SEGMENTS_WRITE = "panel:segments:write"
export const SEGMENTS_DOGFOOD_READ = "panel:segments:dogfood:read"
export const SEGMENTS_DOGFOOD_WRITE = "panel:segments:dogfood:write"
export const BEEHIIV_READ = "panel:beehiiv:read"
export const BEEHIIV_WRITE = "panel:beehiiv:write"
export const FLAGS_READ = "panel:flags:read"
export const FLAGS_WRITE = "panel:flags:write"
export const FLAGS_DOGFOOD_WRITE = "panel:flags:dogfood:write"
export const FLAGS_PROPOSE = "panel:flags:propose"
export const PROMO_READ = "panel:promo:read"
export const PROMO_WRITE = "panel:promo:write"
export const REVIEWS_READ = "panel:reviews:read"
export const REVIEWS_MODERATE = "panel:reviews:moderate"
export const WAITLIST_READ = "panel:waitlist:read"
export const WAITLIST_WRITE = "panel:waitlist:write"
export const AGENTS_READ = "panel:agents:read"
export const AGENTS_WRITE = "panel:agents:write"
export const QA_CLOCK = "qa:clock"
export const QA_WALK = "qa:walk"
export const OPS_JOBS_READ = "panel:ops:jobs:read"
export const OPS_JOBS_REQUEST = "panel:ops:jobs:request"
export const OPS_JOBS_APPROVE = "panel:ops:jobs:approve"
export const SECRETS_READ = "panel:secrets:read"
export const SECRETS_WRITE = "panel:secrets:write"
export const OPS_READ = "panel:ops:read"
export const OPS_WRITE = "panel:ops:write"
export const SIM_READ = "panel:sim:read"
export const SIM_WRITE = "panel:sim:write"
export const MCP_CONNECT = "mcp:connect"

/** Every role and what it grants, from ROLE_SCOPES in scopes.py.
 *
 * Includes `admin`. The panel needs it for one case: resolving a token
 * minted before scopes shipped. Without it, a deploy that reached the
 * panel before the backend would lock every admin out. */
export const ROLE_SCOPES: Record<string, string[]> = {
  "admin": [AGENTS_READ, AGENTS_WRITE, BEEHIIV_READ, BEEHIIV_WRITE, CAMPAIGN_DRAFT, CAMPAIGN_PUBLISH, CAMPAIGN_READ, COMMUNITY_MODERATE, COMMUNITY_READ, EMAIL_ADMIN, EMAIL_READ, EMAIL_SEND, EMAIL_TEST_SELF, EMAIL_WRITE, EXERCISES_PUBLISH, EXERCISES_READ, EXERCISES_WRITE, FEEDBACK_READ, FEEDBACK_WRITE, FLAGS_DOGFOOD_WRITE, FLAGS_PROPOSE, FLAGS_READ, FLAGS_WRITE, INSIGHTS_READ, LESSONS_PUBLISH, LESSONS_READ, LESSONS_WRITE, MAIL_SYSTEM_WRITE, MCP_CONNECT, MEDIA_READ, MEDIA_WRITE, METRICS_READ, METRICS_WRITE, NOTIFICATIONS_READ, NOTIFICATIONS_SEND, OPS_JOBS_APPROVE, OPS_JOBS_READ, OPS_JOBS_REQUEST, OPS_READ, OPS_WRITE, PAYMENTS_GRANT, PAYMENTS_READ, PAYMENTS_SUBSCRIPTIONS_READ, PAYMENTS_TRIAGE, PORTAL_DRAFT, PORTAL_PUBLISH, PORTAL_READ, PRICING_READ, PRICING_WRITE, PROMO_READ, PROMO_WRITE, PUSH_TEST_SELF, QA_CLOCK, QA_WALK, REVIEWS_MODERATE, REVIEWS_READ, SECRETS_READ, SECRETS_WRITE, SEGMENTS_DOGFOOD_READ, SEGMENTS_DOGFOOD_WRITE, SEGMENTS_READ, SEGMENTS_WRITE, SIM_READ, SIM_WRITE, USERS_ACTIVITY_READ, USERS_PII_READ, USERS_READ, USERS_RELEASE_READ, USERS_ROLES_WRITE, USERS_STATIC_CODE_READ, USERS_STATIC_CODE_WRITE, USERS_WRITE, WAITLIST_READ, WAITLIST_WRITE],
  "agent": [FLAGS_DOGFOOD_WRITE, FLAGS_PROPOSE, FLAGS_READ, OPS_JOBS_READ, OPS_JOBS_REQUEST, SEGMENTS_DOGFOOD_READ, SEGMENTS_DOGFOOD_WRITE, USERS_RELEASE_READ],
  "marketing": [BEEHIIV_READ, CAMPAIGN_PUBLISH, CAMPAIGN_READ, EMAIL_READ, EMAIL_SEND, EMAIL_TEST_SELF, EMAIL_WRITE, INSIGHTS_READ, METRICS_READ, PAYMENTS_READ, SEGMENTS_READ, USERS_READ],
  "mcp": [MCP_CONNECT],
  "operator": [AGENTS_READ, AGENTS_WRITE, BEEHIIV_READ, BEEHIIV_WRITE, CAMPAIGN_DRAFT, CAMPAIGN_PUBLISH, CAMPAIGN_READ, COMMUNITY_MODERATE, COMMUNITY_READ, EMAIL_ADMIN, EMAIL_READ, EMAIL_SEND, EMAIL_TEST_SELF, EMAIL_WRITE, EXERCISES_PUBLISH, EXERCISES_READ, EXERCISES_WRITE, FEEDBACK_READ, FEEDBACK_WRITE, FLAGS_DOGFOOD_WRITE, FLAGS_PROPOSE, FLAGS_READ, FLAGS_WRITE, INSIGHTS_READ, LESSONS_PUBLISH, LESSONS_READ, LESSONS_WRITE, MCP_CONNECT, MEDIA_READ, MEDIA_WRITE, METRICS_READ, METRICS_WRITE, NOTIFICATIONS_READ, OPS_JOBS_APPROVE, OPS_JOBS_READ, OPS_JOBS_REQUEST, OPS_READ, OPS_WRITE, PAYMENTS_READ, PAYMENTS_SUBSCRIPTIONS_READ, PAYMENTS_TRIAGE, PORTAL_DRAFT, PORTAL_PUBLISH, PORTAL_READ, PRICING_READ, PRICING_WRITE, PROMO_READ, PROMO_WRITE, PUSH_TEST_SELF, QA_CLOCK, QA_WALK, REVIEWS_MODERATE, REVIEWS_READ, SECRETS_READ, SECRETS_WRITE, SEGMENTS_DOGFOOD_READ, SEGMENTS_DOGFOOD_WRITE, SEGMENTS_READ, SEGMENTS_WRITE, SIM_READ, SIM_WRITE, USERS_ACTIVITY_READ, USERS_PII_READ, USERS_READ, USERS_RELEASE_READ, USERS_WRITE, WAITLIST_READ, WAITLIST_WRITE],
  "ota-tooling": [SEGMENTS_READ, SEGMENTS_WRITE],
  "qa": [QA_CLOCK, QA_WALK],
  "qa_clock": [QA_CLOCK],
  "viewer": [AGENTS_READ, BEEHIIV_READ, CAMPAIGN_READ, COMMUNITY_READ, EMAIL_READ, EXERCISES_READ, FEEDBACK_READ, FLAGS_READ, INSIGHTS_READ, LESSONS_READ, MEDIA_READ, METRICS_READ, NOTIFICATIONS_READ, PAYMENTS_READ, PAYMENTS_SUBSCRIPTIONS_READ, PORTAL_READ, PRICING_READ, PROMO_READ, REVIEWS_READ, SEGMENTS_READ, USERS_ACTIVITY_READ, USERS_PII_READ, USERS_READ, WAITLIST_READ],
  "viewer-config": [FLAGS_READ, REVIEWS_READ, WAITLIST_READ],
  "viewer-content": [AGENTS_READ, EXERCISES_READ, LESSONS_READ, MEDIA_READ, PORTAL_READ],
  "viewer-email": [BEEHIIV_READ, CAMPAIGN_READ, EMAIL_READ, SEGMENTS_READ, USERS_PII_READ],
  "viewer-insights": [INSIGHTS_READ, METRICS_READ, PAYMENTS_READ],
  "viewer-payments": [PAYMENTS_READ, PAYMENTS_SUBSCRIPTIONS_READ, PRICING_READ, PROMO_READ, USERS_PII_READ],
  "viewer-users": [COMMUNITY_READ, FEEDBACK_READ, METRICS_READ, NOTIFICATIONS_READ, USERS_ACTIVITY_READ, USERS_PII_READ, USERS_READ],
}

/** The read-only bundles, for rendering. */
export const VIEWER_BUNDLES: Record<string, string[]> = {
  "viewer-payments": [PAYMENTS_READ, PAYMENTS_SUBSCRIPTIONS_READ, PRICING_READ, PROMO_READ, USERS_PII_READ],
  "viewer-insights": [INSIGHTS_READ, METRICS_READ, PAYMENTS_READ],
  "viewer-users": [COMMUNITY_READ, FEEDBACK_READ, METRICS_READ, NOTIFICATIONS_READ, USERS_ACTIVITY_READ, USERS_PII_READ, USERS_READ],
  "viewer-content": [AGENTS_READ, EXERCISES_READ, LESSONS_READ, MEDIA_READ, PORTAL_READ],
  "viewer-email": [BEEHIIV_READ, CAMPAIGN_READ, EMAIL_READ, SEGMENTS_READ, USERS_PII_READ],
  "viewer-config": [FLAGS_READ, REVIEWS_READ, WAITLIST_READ],
}

/** Roles held by tooling, never by a person (MACHINE_ROLES). */
export const MACHINE_ROLES: string[] = [
  "agent",
  "ota-tooling",
]

/** Every scope that exists. */
export const ALL_SCOPES: string[] = [
  "mcp:connect",
  "panel:agents:read",
  "panel:agents:write",
  "panel:beehiiv:read",
  "panel:beehiiv:write",
  "panel:campaign:draft",
  "panel:campaign:publish",
  "panel:campaign:read",
  "panel:community:moderate",
  "panel:community:read",
  "panel:email:admin",
  "panel:email:read",
  "panel:email:send",
  "panel:email:test:self",
  "panel:email:write",
  "panel:exercises:publish",
  "panel:exercises:read",
  "panel:exercises:write",
  "panel:feedback:read",
  "panel:feedback:write",
  "panel:flags:dogfood:write",
  "panel:flags:propose",
  "panel:flags:read",
  "panel:flags:write",
  "panel:insights:read",
  "panel:lessons:publish",
  "panel:lessons:read",
  "panel:lessons:write",
  "panel:mail:system:write",
  "panel:media:read",
  "panel:media:write",
  "panel:metrics:read",
  "panel:metrics:write",
  "panel:notifications:read",
  "panel:notifications:send",
  "panel:ops:jobs:approve",
  "panel:ops:jobs:read",
  "panel:ops:jobs:request",
  "panel:ops:read",
  "panel:ops:write",
  "panel:payments:grant",
  "panel:payments:read",
  "panel:payments:subscriptions:read",
  "panel:payments:triage",
  "panel:portal:draft",
  "panel:portal:publish",
  "panel:portal:read",
  "panel:pricing:read",
  "panel:pricing:write",
  "panel:promo:read",
  "panel:promo:write",
  "panel:push:test:self",
  "panel:reviews:moderate",
  "panel:reviews:read",
  "panel:secrets:read",
  "panel:secrets:write",
  "panel:segments:dogfood:read",
  "panel:segments:dogfood:write",
  "panel:segments:read",
  "panel:segments:write",
  "panel:sim:read",
  "panel:sim:write",
  "panel:users:activity:read",
  "panel:users:pii:read",
  "panel:users:read",
  "panel:users:release:read",
  "panel:users:roles:write",
  "panel:users:static-code:read",
  "panel:users:static-code:write",
  "panel:users:write",
  "panel:waitlist:read",
  "panel:waitlist:write",
  "qa:clock",
  "qa:walk",
]
